<template>
<!-- 요일 입력 팝업 -->
<div class="modal fade" id="enrollDate" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered w-350px" role="document">
        <div class="modal-content">
            <a type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">
                    <img src="../../../assets/img/close.png" alt="close" class="pointer close-btn mr-10 mt-10">
                </span>
            </a>
            <div class="modal-body">
                <div class="txt-center">
                    <h3 class="font-14 bold">요일 입력</h3>
                    <div class="mt-10 mb-10">
                        <input type="checkbox" v-model="day.mon.value" /> 월
                        <input type="checkbox" class="ml-05" v-model="day.tue.value" /> 화
                        <input type="checkbox" class="ml-05" v-model="day.wed.value" /> 수
                        <input type="checkbox" class="ml-05" v-model="day.thu.value" /> 목
                        <input type="checkbox" class="ml-05" v-model="day.fri.value" /> 금
                        <input type="checkbox" class="ml-05" v-model="day.sat.value" /> 토
                        <input type="checkbox" class="ml-05" v-model="day.sun.value" /> 일
                    </div>
                </div>
            </div>
            <div class="modal-footer txt-center">
                <a class="admin-btn-default btn pointer mg-auto" @click="exportData()" data-dismiss="modal" aria-label="Close">입력 완료</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['gridIndex', 'rowIndex', 'parentDate'],
    data: () => ({
        day: {
            mon: {
                value: false,
                name: '월'
            },
            tue: {
                value: false,
                name: '화'
            },
            wed: {
                value: false,
                name: '수'
            },
            thu: {
                value: false,
                name: '목'
            },
            fri: {
                value: false,
                name: '금'
            },
            sat: {
                value: false,
                name: '토'
            },
            sun: {
                value: false,
                name: '일'
            }
        }
    }),
    mounted () {
        if (this.parentDate !== '') {
            for (let item in this.day) {
                for (let strDay of this.parentDate.split('^')) {
                    if (this.day[item].name === strDay) {
                        this.day[item].value = true
                        continue
                    }
                }
            }
            // this.day = this.parentDate
        }
    },
    
    beforeDestroy () {
    },

    methods: {
        exportData () {
            var selectedDays = []
            for (var item of Object.keys(this.day)) {
                if (this.day[item].value) {
                    selectedDays.push(this.day[item].name)
                }
            }
            selectedDays = selectedDays.join('^')

            this.$emit('applyDate', selectedDays, this.gridIndex, this.rowIndex)
        }
    }
}
</script>
